import moment from 'moment';
import { put, takeLatest } from 'redux-saga/effects';
import handleException from '../services/handleException';
import { addPackageInfo, deleteShipment, clearShipmentFailFeeds, getLabelsInfo, getPackageInfoById, getPackageInfoByShipmentId, getShipments, toTransmited, getExportShipmentData } from '../utils/shipment';
import { TO_TRANSMITED_SHIPMENT_FAILS } from './../actions/shipmentAction';
import { shipmentStatus, StatusFilterShipment, FulfillOption } from './../constants';
import { convertDateToUTC } from './../services/dst';
import hanldeException from './../services/handleException';
import { getShipmentParams, renderListShipment } from './../services/helper';
import store from './../store';
import {ON_CLEAR_FEED, CLEAR_FEED_SUCCESS, CLEAR_FEED_FAILURE} from '../actions/shipmentAction';

const defaultParams = {
    IsDesc: true,
    OrderBy: "LastUpdateDT",
    Page: 1,
    PageSize: 50,
    Status: [shipmentStatus.AWAITING_PACKAGE_INFO],
    SelectedIds: [],
}
function* getShipmentsSortHandle(data) {
    let params = {
        ...data.payload.params,
        OrderBy: data.payload.column,
    }
    try {
        const json = yield getShipments(params)
        if (json.data.code === 10001) {
            yield put({ type: 'GET_SHIPMENT_SUCCESS', json })
        } else {
            yield put({ type: 'GET_SHIPMENT_FAILURE', json })
        }
    } catch (error) {
        hanldeException(error)
    }
}
function* submit_shipment(data) {
    try {
        const json = yield getShipments(data.payload)
        if (json.data.code === 10001) {
            yield put({ type: 'GET_SHIPMENT_SUCCESS', json })
        } else {
            yield put({ type: 'GET_SHIPMENT_FAILURE', json })
        }
    } catch (error) {
        hanldeException(error)
    }
}

function* getShipmentsByPageHandle(data) {
    let params = {
        ...data.payload.params,
        Page: data.payload.current_page,
    }
    try {
        const json = yield getShipments(params)
        if (json.data.code === 10001) {
            yield put({ type: 'GET_SHIPMENT_SUCCESS', json })
        } else {
            yield put({ type: 'GET_SHIPMENT_FAILURE', json })
        }
    } catch (error) {
        hanldeException(error)
    }
}

function* getShipmentsByNextOrBackHandle(data) {
    let params
    if (data.payload.type === 'back') {
        params = {
            ...data.payload.params,
            Page: data.payload.current_page - 1,
        }
    }
    if (data.payload.type === 'back-head') {
        params = {
            ...data.payload.params,
            Page: 1,
        }
    }
    if (data.payload.type === 'next') {
        params = {
            ...data.payload.params,
            Page: data.payload.current_page + 1,
        }
    }
    if (data.payload.type === 'next-last') {
        params = {
            ...data.payload.params,
            Page: data.payload.pages,
        }
    }
    try {
        const json = yield getShipments(params)
        if (json.data.code === 10001) {
            yield put({ type: 'GET_SHIPMENT_SUCCESS', json })
        } else {
            yield put({ type: 'GET_SHIPMENT_FAILURE', json })
        }
    } catch (error) {
        hanldeException(error)
    }
}

function* getShipmetOnTabHandle(data) {
    let startToday = moment().format('MM/DD/YYYY') + ' 00:00:00'
    let endToday = moment().format('MM/DD/YYYY') + ' 23:59:59'
    let params = {
        ...defaultParams,
        Status: parseInt(data.payload.tab, 10) === 4 ? [StatusFilterShipment.SHIPPED, StatusFilterShipment.IN_TRANSIT] : [parseInt(data.payload.tab, 10)],
        FulfillmentOption: data.payload.FulfillmentOption ? data.payload.FulfillmentOption : FulfillOption.IN_HOUSE.CODE,
        PageSize: data.payload.PageSize,
        ShippingDateFrom: parseInt(data.payload.tab, 10) === 4 ? convertDateToUTC(new Date(startToday)) : undefined,
        ShippingDateTo: parseInt(data.payload.tab, 10) === 4 ? convertDateToUTC(new Date(endToday)) : undefined,
        StartToday: convertDateToUTC(new Date(startToday)),
        EndToday: convertDateToUTC(new Date(endToday)),
    }
    try {
        const json = yield getShipments(params)
        if (json.data.code === 10001) {
            yield put({ type: 'GET_SHIPMENT_SUCCESS', json })
        } else {
            handleException(json)
        }
    } catch (error) {
        hanldeException(error)
    }
}

function* resetShipmentFilterHandle(data) {
    try {
        let startToday = moment().format('MM/DD/YYYY') + ' 00:00:00'
        let endToday = moment().format('MM/DD/YYYY') + ' 23:59:59'
        const json = yield getShipments({
            ...defaultParams,
            PageSize: data.payload.PageSize,
            Status: data.payload.FulfillmentOption === FulfillOption.YAMATO.CODE ? [shipmentStatus.FULFILLMENT_IN_PROCESS] : [shipmentStatus.AWAITING_PACKAGE_INFO],
            FulfillmentOption: data.payload.FulfillmentOption ? data.payload.FulfillmentOption : FulfillOption.IN_HOUSE.CODE,
            StartToday: convertDateToUTC(new Date(startToday)),
            EndToday: convertDateToUTC(new Date(endToday)),
        })
        if (json.data.code === 10001) {
            yield put({ type: 'GET_SHIPMENT_SUCCESS', json })
        } else {
            handleException(json)
        }
    } catch (error) {
        hanldeException(error)
    }
}

function* deleteShipmentsHandle(data) {
    try {
        const json = yield deleteShipment(data.payload)
        if (json.data.code === 10001) {
            yield put({ type: 'DELETE_SHIPMENT_SUCCESS', json })
        } else {
            yield put({ type: 'DELETE_SHIPMENT_FAILURE', json })
            hanldeException(json)
        }
    } catch (error) {
        hanldeException(error)
    }
}

function* clearShipmentFailFeedsHandle(data){
    try{
        const json = yield clearShipmentFailFeeds(data.payload)
        if(json.data.code === 10001){
            yield put({type: CLEAR_FEED_SUCCESS, json})
        }else{
            yield put({type: CLEAR_FEED_FAILURE, json})
            hanldeException(json);
        }
    }catch(error){
        hanldeException(error);
        yield put({type: CLEAR_FEED_FAILURE, payload: null})
    }
}

function* toTransmitedShipmentHandle(data) {
    try {
        const json = yield toTransmited(data.payload)
        let stateInStore = getShipmentParams(store.getState(), 'notChecked')

        if (json.data.code === 10001 || json.data.code === 311805 || json.data.code === 0) {
            yield put(
                { 
                    type: 'TO_TRANSMITED_SHIPMENT_SUCCESS',
                    payload: { 
                        data: json.data.data
                    }
                })
        } else {
            yield put({ type: TO_TRANSMITED_SHIPMENT_FAILS, json })
            yield put({ type: 'ON_SUBMIT_SHIPMENT', payload: { ...stateInStore, isKeepState: true } })
            handleException(json)
        }
    } catch (error) {
        yield put({ type: TO_TRANSMITED_SHIPMENT_FAILS, error })
        hanldeException(error)
    }
}

function* getLabelInfoHandle(data) {
    try {
        const json = yield getLabelsInfo(data.payload)
        if (json.data.type === 'application/pdf' && json.data) {
            yield put({ type: 'GET_LABEL_INFO_SUCCESS', payload: json })
            renderListShipment()
        } else {
            let reader = new FileReader();
            reader.addEventListener("loadend", () => {
                let codeRes = JSON.parse(reader.result);
                if (codeRes.code === 10001) {
                    store.dispatch({ type: 'GET_LABEL_INFO_NOT_PDF_SUCCESS', payload: json })
                    renderListShipment()
                } else {
                    store.dispatch({ type: 'GET_LABEL_INFO_FAILURE', payload: json })
                    let data = { data: codeRes }
                    hanldeException(data)
                }
                
            });
            reader.readAsText(json.data);
        }
    } catch (error) {
        hanldeException(error)
    }
}

function* getPackageInfoHandle(data) {
    try {
        const json = yield getPackageInfoById({ PackageIDs: data.payload })
        if (json.data.code === 10001) {
            yield put({ type: 'GET_PACKAGE_INFO_SUCCESS', payload: json })
        } else {
            hanldeException(json)
            yield put({ type: 'GET_PACKAGE_INFO_FAILURE', payload: json })
        }
    } catch (error) {
        hanldeException(error)
    }
}
function* getPackageInfoByShipmentIdHandle(data) {
    try {
        const json = yield getPackageInfoByShipmentId({ ShipmentIDs: data.payload })
        if (json.data.code === 10001) {
            yield put({ type: 'GET_PACKAGE_INFO_BY_SHIPMENT_ID_SUCCESS', payload: json })
        } else {
            hanldeException(json)
            yield put({ type: 'GET_PACKAGE_INFO_BY_SHIPMENT_ID_FAILURE', payload: json })
        }
    } catch (error) {
        hanldeException(error)
    }
} 
function* submitAddPackageInfoHandle(data) {
    let params = {
        PackageIds: data.payload.ids,
        GrossWeightFL: data.payload.value.pgw,
        WeightUnitCH: data.payload.value.pgw_unit,
        HeightFL: data.payload.value.h,
        LengthFL: data.payload.value.l,
        WidthFL: data.payload.value.w,
        LengthUnitCH: data.payload.value.lwh_unit,
        ServiceType: data.payload.value.shiper_st ? data.payload.value.st : 'K',
        VolumeWeightFL: data.payload.value.pvw && data.payload.value.pvw !== Infinity ? data.payload.value.pvw : 0
    }
    try {
        const json = yield addPackageInfo(params)
        if (json.data.code === 10001) {
            yield put({ type: 'ADD_PACKAGE_INFO_SUCCESS', json })
        } else {
            hanldeException(json)
            yield put({ type: 'ADD_PACKAGE_INFO_FAILURE', payload: json })
        }
    } catch (error) {
        hanldeException(error)
    }
}

export function* submitShipment() {
    yield takeLatest('ON_SUBMIT_SHIPMENT', submit_shipment)
}

export function* getShipmentsSort() {
    yield takeLatest('ON_SORT_SHIPMENT', getShipmentsSortHandle)
}

export function* getShipmentsByPage() {
    yield takeLatest('ON_GET_SHIPMENT_BY_PAGE', getShipmentsByPageHandle)
}
export function* getShipmentsByNextOrBack() {
    yield takeLatest('ON_NEXT_OR_BACK_SHIPMENT', getShipmentsByNextOrBackHandle)
}
export function* getShipmetOnTab() {
    yield takeLatest('ON_TAB_SHIPMENT', getShipmetOnTabHandle)
}
export function* resetShipmentFilter() {
    yield takeLatest('ON_RESET_SHIPMENT_FILTER', resetShipmentFilterHandle)
}
export function* deleteShipments() {
    yield takeLatest('ON_DELETE_SHIPMENT', deleteShipmentsHandle)
}
export function* clearShipmentFeeds(){
    yield takeLatest(ON_CLEAR_FEED, clearShipmentFailFeedsHandle)
}
export function* submitAddPackageInfo() {
    yield takeLatest('ON_SUBMIT_PACKAGE_INFO', submitAddPackageInfoHandle)
}

export function* toTransmitedShipment() {
    yield takeLatest('TO_TRANSMITED', toTransmitedShipmentHandle)
}
export function* getLabelInfo() {
    yield takeLatest('GET_LABEL_INFO', getLabelInfoHandle)
}
export function* getPackageInfo() {
    yield takeLatest('GET_PACKAGE_INFO_BY_ID', getPackageInfoHandle)
}
export function* getPackageInfoShipmentId() {
    yield takeLatest('GET_PACKAGE_INFO_BY_SHIPMENT_ID', getPackageInfoByShipmentIdHandle)
}



// WEBPACK FOOTER //
// ./src/sagas/shipmentSaga.js